<template>
  <div class="pc-course">
    <BreadCrumb :data="breadcrumb" :title="'课程列表管理'" />
    <StatisticalPanel
      :whichModule="'lecture'"
      :data="overallData"
    ></StatisticalPanel>
    <SeriesList />
    <ModuleClassfication
      :title="topics"
      class="pc-Lecture-tab"
      @addTopic="addTopic"
      @updateTopic="updateTopic"
      @deleteTopic="deleteTopic"
    />
    <LectureTable />
  </div>
</template>

<script>
import BreadCrumb from "../../componentSet/BreadCrumb";
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel";
import ModuleClassfication from "../../componentSet/ModuleClassfication";
import LectureTable from "./components/LectureTable";
import SeriesList from "./components/seriesList.vue";
import {
  getLectureCount_Api,
  getLectureTopics_Api,
  addLectureTopics_Api,
  updateLectureTopics_Api,
  deleteLectureTopics_Api
} from "../../../apis/lecture.api";
export default {
  data() {
    return {
      overallData: {
        title: "课程数据",
        count: [
          { name: "上线课程", count: null },
          { name: "课程系列", count: null },
        ],
      },
      topics: {
        module: "课程",
        class: [{ name: "Category 学科编码", subTitles: [] }],
      },
    };
  },
  components: {
    BreadCrumb,
    ModuleClassfication,
    LectureTable,
    SeriesList,
    StatisticalPanel,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "课程列表", link: "/admin/lecture" },
      ];
    },
  },
  mounted() {
    getLectureCount_Api().then((res) => {
      this.$set(this.overallData.count[0], "count", res.data.lecture_count);
      this.$set(this.overallData.count[1], "count", res.data.series_count);
    });
    this.getLectureTopic()
  },
  methods: {
    updateTopic(topic, callback) {
       if (topic.type == "Category 学科编码") {
        updateLectureTopics_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          classification_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.getLectureTopic();
        });
      }
    },
    addTopic(topic, callback) {
       if (topic.type == "Category 学科编码") {
        addLectureTopics_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          status: topic.status,
        }).then(() => {
          callback();
          this.getLectureTopic();
        });
      }
    },
    deleteTopic(topic, callback) {
      console.log(topic);
       if (topic.type == "Category 学科编码") {
        deleteLectureTopics_Api({ classification_id: topic.id }).then(() => {
          callback();
          this.getLectureTopic();
        });
      }
    },
    getLectureTopic() {
      getLectureTopics_Api().then((res) => {
        this.$set(this.topics.class[0], "subTitles", res.data);
        console.log(this.topics);
      });
    },
  },
};
</script>



<style lang="scss"  scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/lecture/LectureList.vue